import { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { formatDate } from "../../utilities/helper";
import { MenuContext } from "../../App";
import SearchedComponent from "../../components/SearchedComponent";
import { fetchAllCohortManagementDataService } from "../../services/cohortManagementService";
import useDebounceSearch from "../../hooks/useDebounceSearch";

const CohortManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [canAddCohort, setCanAddCohort] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      fetchAllCohortManagementData(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanAddEditCohorts"
      );
      if (createFound) {
        canAdd = true;
      }
      setCanAddCohort(canAdd);
    } else if (role === "Admin") {
      setCanAddCohort(true);
    }
  }, [systemActions]);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <>
            <button
              className="bread-crumbs-link grid-nav-btn"
              onClick={() => {
                navigate("/addUpdate-cohort-management", {
                  state: {
                    id: id,
                  },
                });
              }}
            >
              {name}
            </button>
          </>
        );
      },
    },
    {
      field: "capacity",
      headerName: "Capacity",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Capacity"}</div>,
      renderCell: (params) => {
        const capacity = params.row.capacity;

        return <span className="data-font">{capacity}</span>;
      },
    },
    {
      field: "openedDate",
      headerName: "Opened Date",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Opened Date"}</div>,
      renderCell: (params) => {
        const openedDate = params.row.openedDate;
        return (
          <span className="data-font">
            {openedDate !== "" ? formatDate(openedDate) : ""}
          </span>
        );
      },
    },
    {
      field: "closedDate",
      headerName: "Closed Date",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Closed Date"}</div>,
      renderCell: (params) => {
        const closedDate = params.row.closedDate;
        return (
          <span className="data-font">
            {closedDate !== "" ? formatDate(closedDate) : ""}
          </span>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Active",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Active"}</div>,
      renderCell: (params) => {
        const isActive = params.row.isActive;

        return (
          <span className="data-font">
            {isActive == "Yes" ? "True" : "False"}
          </span>
        );
      },
    },
  ];

  const fetchAllCohortManagementData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllCohortManagementDataService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/cohort-management">
            Cohort Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Cohort Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Cohort"
                searchedValue={searchedValue}
              />
              {canAddCohort ? (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-cohort-management")}
                >
                  Add New Cohort
                </button>
              ) : null}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default CohortManagement;
